import { dataOrElse, Games, Tokens, Translate } from '@nackle/arcade-core-v2';
import { Typography, Divider, Tag } from '@nackle/origami';
import React from 'react';
import { connect } from 'react-redux';
import { lruMemoize } from 'reselect';
import CabinetItem from './CabinetItem';
import './RoomCabinetList.less';

const { Title } = Typography;

const mapStateToProps = () => {
  const getCabinetList = lruMemoize( ( state, room ) => {
    return room.cabinets
      .map( ( cabinet ) => Games.getCabinetById( state, cabinet.cabinetId ) )
      .filter( ( cabinet ) => Boolean( cabinet ) );
  } );

  return ( state, props ) => {
    return {
      cabinets: getCabinetList( state, props.room ),
      name: dataOrElse( Games.getRoomName( state, props.room.id ), '' ),
      roomTokenCount:
        dataOrElse(
          Tokens.countAvailableTokensForRoom( state, props.room.id ),
          0,
        ) || 0,
    };
  };
};

class RoomCabinetList extends React.Component {
  render() {
    const { cabinets, room, roomTokenCount, roomName } = this.props;
    return (
      <>
       { roomTokenCount !== 0 && (
      <div className="room-content">
        <div className="room-header">
          <div className="room-divider">
            <Divider />
          </div>
          <div className="room-header-text">
            <Title level={ 2 } strong>
              { roomName }
            </Title>

            <div className="room-tag" key={ roomTokenCount }>
              <Tag.Color size="medium" status={ 'processing' } >
                { roomTokenCount === 1
                  ? <>{ roomTokenCount } &nbsp;<Translate id='arcade.webapp.gamePlay'/> </>
                  : <>{ roomTokenCount } &nbsp;<Translate id='arcade.webapp.gamePlays'/> </> }
              </Tag.Color>
            </div>
          </div>
        </div>
        <div className="room-container-grid"> 
        <div className="room-cabinet-list">
          { cabinets.map( ( cabinet ) => (
            <CabinetItem
              cabinet={ cabinet }
              key={ cabinet.cabinetId }
              roomId={ room.id }
              tokenCount={ roomTokenCount }
              isUmbrella={ this.props.isUmbrella }
            />
          ) ) }
          
          
        </div>
        </div>
       </div>
       )
      }
      </>
    );
  }
}

export default connect( mapStateToProps )( RoomCabinetList );
